module.exports = __webpack_public_path__ + "img/7.8d8ce22f.png";